module.exports = __webpack_public_path__ + "assets/img/monitor-empty.78ab02b4.png";